import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { IconsService } from '../../core/services/icons.service';
import { MessagingEnvironmentService } from '../../core/services/messaging-environment.service';

@NgModule({
  declarations: [],
  imports: [
    OverlayModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatSlideToggleModule,
  ],
  exports: [
    OverlayModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatSlideToggleModule,
  ],
  providers: [],
})
export class MessagingMaterialModule {
  constructor(private iconsService: IconsService, private env: MessagingEnvironmentService) {
    if (this.env?.env?.assetsNgxMessaging) {
      this.iconsService.loadIcons(this.env.env.assetsNgxMessaging);
    }
  }
}
